type MailtoOptions = {
  to: string
  subject: string
  body: string
}

export function buildWhatsAppLink(phoneNumber: string, message: string): string {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
}

export function buildMailtoLink({ to, subject, body }: MailtoOptions): string {
  const query = new URLSearchParams({
    subject,
    body,
  })

  return `mailto:${to}?${query.toString()}`
}
